<template>
  <div class="container d-flex flex-wrap mb-3">
    <div>
      <ncs-pagination-title/>
      <ncs-pagination-links/>
    </div>
    <ncs-go-to-page class="ml-auto align-self-end"/>
    <div class="ml-auto align-self-end mt-3">
      <ncs-download-button/>
    </div>
  </div>
</template>
<script>
  export default {}
</script>
